import { HEX_292D38, HEX_FFFFFF } from '@tanium/colors';
import { defineColor, ModuleIcon } from '@tanium/react-theme-definition';

export const OuterSpinnerStroke = defineColor([HEX_292D38, HEX_FFFFFF]);

export const TaniumIconFill = ModuleIcon;
